import * as React from 'react';

import { useState, useEffect } from "react";
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import StatusContext from '../../../contexts/StatusContext'
import AuthContext from "../../../contexts/AuthContext";
import { PushButton } from '../pushbutton/PushButton';
import axios from 'axios'
import { config } from "../../../config";
import "./signupdialog.css";
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { SignupConfirmDialog } from '../signupconfirmdialog/SignupConfirmDialog';
import CircularProgress from '@mui/material/CircularProgress';


export const  SignupDialog = () => {

    const [statusregister, setStatusRegister] = useState('')

     
      const {
        changeLanguage,
        isLoading,
        setIsLoading,
        showsignupdialog,
        setShowSignupDialog,
        setShowSignupConfirmDialog,
        setEnableSignupDialog, 
        enablesignupdialog,
        openDialogBoxConfirm,
        setSecurityCodeStatus,
       
    } = React.useContext(StatusContext);

    const {
      setCurrentUser, 
    } = React.useContext(AuthContext);

     

      const[inputs, setInputs] = useState({
        username:"",
        email:"",
        confirmemail:"",
        confirmusername: "",
        password:"",
        confirmpassword: "",
      })

    const verifySecurityCode = async (securitycode) => {

        const userid = JSON.parse(localStorage.getItem('UserSignupVerification'))

      if (securitycode === userid.verificationtoken)
      {

        try {
          const res = await axios.post(config.url.API_URL + "/deda_ai_api/auth/register", userid)
        
          if (res.status === 200) {
            localStorage.setItem("user", userid.email)
            setCurrentUser(userid.email)
          }
          else{
            console.log("Registration error:", res.status)
            return
          }
      
        } catch (err) {
            console.log("Register err:", err.response.data)
            if (err.response && err.response.data.code === "ECONNRESET")
            {
              setStatusRegister("Network error.")
            }
            else{
              setStatusRegister(err.response.data)
            }
            setShowSignupConfirmDialog(false)
            return;
        } 
      }
      else{
        setSecurityCodeStatus(changeLanguage("signup", "invalidsecuritycode"))
        return
      }
        setEnableSignupDialog(false)
        setShowSignupDialog(false)
        setShowSignupConfirmDialog(false)
        openDialogBoxConfirm()

        //send to me email notification
        let req= {
          useremail: userid.email
        }
        await axios.post(config.url.API_URL + "/deda_ai_api/auth/newusernotification", req)
  }

   
      const handleChange = (e) => {
          setInputs((prev)=>({...prev,[e.target.name]: e.target.value }))
          setStatusRegister('')
      }

      useEffect(() => {

      console.log("useEffect - Signup dialog ")

    }, [])   

     

      // eslint-disable-next-line
      const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

      const isValidEmail = (email) => {
        return emailRegex.test(String(email).toLowerCase());
      }

      
      const handleSignup = async (e) =>{
 
        setStatusRegister("")
      
        e.preventDefault()

        if (!isValidEmail(inputs.email))
        {
          setStatusRegister(changeLanguage('status', 'invalidemail'))
          return;
        }
    
        if (!isValidEmail(inputs.confirmemail))
        {
          setStatusRegister(changeLanguage('status', 'invalidconfirmemail'))
          return;
        }
    
        if (inputs.email !== inputs.confirmemail)
        {
          setStatusRegister(changeLanguage('status', 'emailmismatch'))
          return;
        }
    
        if (inputs.password.length < 8)
        {
          setStatusRegister(changeLanguage('status', 'passwordlength'))
          return;
        }
        
        if (inputs.password !== inputs.confirmpassword)
        {
          setStatusRegister(changeLanguage('status', 'passwordmismatch'))
          return;
        }
    
      
        setStatusRegister('')

        //check if user already exists
        let userid = ({
          username:inputs.email,
          email:inputs.email,
          password:inputs.password,
          credits: 10000,
         
          verificationtoken: Math.random().toString(36).substring(2, 8), //6 char string
          
        })

        setIsLoading(true)
    

        try {
          const res = await axios.post(config.url.API_URL + "/deda_ai_api/auth/checkuser", userid)
         
          if (res.status === 200)
          {
            setStatusRegister(changeLanguage('login', 'userexists'))
            setIsLoading(false)
            return
          }
            
        } catch (err) {
           
            if (err.response && err.code === "ECONNRESET")
            {
              setStatusRegister("Connection error")
              setIsLoading(false)
              return
            }

            if (err.response && err.response.status !== 404)
            {
              setStatusRegister("Connection error")
              setIsLoading(false)
              return;
            }
        }
   
        try {
         
          localStorage.setItem("UserSignupVerification", JSON.stringify(userid))
          const res = await axios.post(config.url.API_URL + "/deda_ai_api/auth/send-verification", userid)
          console.log("Email verification sent::", res)
          
          setIsLoading(false)
          setShowSignupConfirmDialog(true)
         
        } catch (err) {
            console.log("Register err:", err.response.data)
            if (err.response && err.code === "ECONNRESET")
              setStatusRegister("Connection error")
            else{
              setStatusRegister("Server error")
            }
            setIsLoading(false)
            return;
        }
    }

  const handleClose = () => {

    setEnableSignupDialog(false)
    setShowSignupDialog(false);
  };

  return (
    <React.Fragment>
      {
         isLoading &&
            <div className='wait-icon'>
                <CircularProgress style={{ color: 'maroon' }}/>
            </div>
      }
      <Dialog
        open={showsignupdialog}
       
        PaperProps={{
          component: 'form',
          onSubmit: (event) => {
            event.preventDefault();
            const formData = new FormData(event.currentTarget);
            const formJson = Object.fromEntries(formData.entries());
            const email = formJson.email;
            console.log(email);
            handleClose();
          },
        }}
      >
        <DialogTitle style={{height: '20px'}}>{changeLanguage('signup', 'signup')}</DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogTitle className='signupDialogTitle'>{changeLanguage('signup', 'signuptext')}</DialogTitle>
       
       
        <DialogContent>
          <div>

              <TextField
                autoFocus
                required
                margin="dense"
              
                name="email"
                label="Email Address"
                type="email"
                fullWidth
                variant="standard"
                onChange = {handleChange}
                value = {inputs.email}
              />

              <TextField 
                autoFocus
                required
                margin="dense"
              
                name="confirmemail"
                label="Confirm Email Address"
                type="email"
                fullWidth
                variant="standard"
                onChange = {handleChange}
                value = {inputs.confirmemail}
              />

              <TextField 
                autoFocus
                required
                margin="dense"
              
                name="password"
                label="Password"
                type="password"
                fullWidth
                variant="standard"
                onChange = {handleChange}
                value = {inputs.password}
              />

              <TextField
                autoFocus
                required
                margin="dense"
              
                name="confirmpassword"
                label="Confirm password"
                type="password"
                fullWidth
                variant="standard"
                onChange = {handleChange}
                value = {inputs.confirmpassword}
              />

        
              <br></br>
              <br></br>
              <div style = {{marginTop: '10px'}}>
                <PushButton label={changeLanguage('signup', 'signup')} onClick={handleSignup}/>
              </div>
              
                {
                 <div className='loginStatus'><label>{statusregister}</label></div>
                }
             
            </div>
        </DialogContent>
      

      </Dialog>

      {
        enablesignupdialog &&
      <SignupConfirmDialog title={"Sign up"} text={changeLanguage('status', 'emailverification')} verifySecurityCode = {verifySecurityCode}/>
      }
    </React.Fragment>
    
  )
}